import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Tooltip,
} from "reactstrap";

import { Link } from "react-router-dom";

import Shimmer from "react-shimmer-effect";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/pensiunskService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import ReactTimeAgo from "react-time-ago";

const reformatDate = (date) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;

  return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
};

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();

  source;
  historyTable = "pensiunDataTableActive";
  defaultOrder = "retired_employee_nip";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil di nonaktifkan";
  modal_confirm_error_message = "data gagal di nonaktifkan";

  constructor(props) {
    super(props);
    this.state = {
      detail: {
        tanggal: "",
        uuid: "",
        keterangan: "",
      },
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      submitUuid: null,
      approveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    let uuid = urlParams.get("uuid");

    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      uuid: uuid,
      role_id: localStorage.getItem("currentRoleId"),
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.inactiveData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  activeData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    // this.dataTableBloc.detailSubmissionChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED:
    //       if (result.data.status) {
    //         let response = result.data.response;
    //         this.setState({
    //           detail: {
    //             // uuid: response.result.emp_retired_submission_uuid,
    //             tanggal: reformatDate(
    //               response.result.emp_retired_submission_date
    //             ),
    //             keterangan: response.result.emp_retired_submission_description,
    //           },
    //         });
    //       }
    //       break;
    //     case apiResponse.ERROR:
    //       break;
    //     default:
    //       break;
    //   }
    // });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    const queryParams = new URLSearchParams(window.location.search).get("uuid");
    this.dataTableBloc.fetchDetailSubmission({ uuid: queryParams });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
  }

  columns = [
    {
      key: "retired_employee_nip",
      text: "Pegawai",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html:
                "<b>" +
                record.retired_employee_nip +
                "</b><br>" +
                record.retired_employee_name +
                "<br>",
            }}
          />
        );
      },
    },
    {
      key: "retired_employee_position_name",
      text: "Posisi",
      className: "retired_employee_position_name", //
      sortable: true,
    },
    {
      key: "retired_employee_work_unit_name",
      text: "Unit Kerja",
      className: "retired_employee_work_unit_name", //
      sortable: true,
    },
    {
      key: "retired_employee_position_name",
      text: "Jabatan",
      className: "retired_employee_position_name",
      sortable: true,
    },
    {
      key: "retired_employee_position_tmt",
      text: "TMT Jabatan",
      className: "retired_employee_position_tmt",
      sortable: true,
    },
    {
      key: "retired_employee_level_name",
      text: "Golongan",
      className: "retired_employee_level_name",
      sortable: true,
    },
    {
      key: "retired_employee_retired_date",
      text: "Tgl Pemberhentian",
      className: "retired_employee_retired_date",
      sortable: true,
    },
    {
      key: "retired_employee_retired_date_tmt",
      text: "TMT Pemberhentian",
      className: "retired_employee_retired_date_tmt",
      sortable: true,
    },
    {
      key: "retired_type_name",
      text: "Jenis",
      className: "retired_type_name",
      sortable: true,
    },
    {
      key: "retired_type_stop_name",
      text: "Jenis Pemberhentian",
      className: "retired_type_stop_name",
      sortable: true,
    },
    {
      key: "employee_age",
      text: "Usia Sekarang",
      className: "employee_age",
      sortable: true,
    },
    {
      key: "employee_age_retired",
      text: "Usia Pemberhentian",
      className: "employee_age_retired",
      sortable: true,
    },
    {
      key: "retired_employee_status",
      text: "Status",
      className: "retired_employee_status",
      sortable: true,
      cell: (record) => {
        var status = record.retired_employee_status;
        return (
          <span>
            {parseInt(status) === -1 ? (
              <label className="badge rounded-pill bg-soft-danger font-size-12">
                Ditolak
              </label>
            ) : (
              <label></label>
            )}
            {parseInt(status) === 0 ? (
              <label className="badge rounded-pill bg-soft-warning font-size-12">
                Menunggu Proses
              </label>
            ) : (
              <label></label>
            )}
            {parseInt(status) === 1 ? (
              <label className="badge rounded-pill bg-soft-success font-size-12">
                Disetujui
              </label>
            ) : (
              <label></label>
            )}
          </span>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 200,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.retired_uuid;
        var status = record.retired_employee_status;
        var has_sk = record.has_sk;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  debugger;
                  this.setState({
                    detailUuid: thisId,
                  });
                  console.log(thisId);
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detil
              </Tooltip>
            </span>
            {accessRole("update") &&
            (parseInt(status) === -2 || parseInt(status) === 0) ? (
              <span>
                <button
                  className="btn btn-warning btn-sm"
                  id={"update-" + thisId}
                  onClick={() => {
                    this.setState({
                      updateUuid: record.retired_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-pen"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["update" + thisId]}
                  target={"update-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["update" + thisId]: !this.state["update" + thisId],
                    });
                  }}
                >
                  Perbaharui
                </Tooltip>
              </span>
            ) : null}
            {/* {parseInt(status) === 1 && parseInt(has_sk) === 0 ? (
              <span>
                <button
                  className="btn btn-success btn-sm"
                  id={"submit-" + thisId}
                  onClick={() => {
                    this.setState({
                      submitUuid: record.retired_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-file-search-alt"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["submit" + thisId]}
                  target={"submit-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["submit" + thisId]: !this.state["submit" + thisId],
                    });
                  }}
                >
                  Verifikasi SK Pemberhentian
                </Tooltip>
              </span>
            ) : null}
            {parseInt(status) === 0 ? (
              <span>
                <button
                  className="btn btn-success btn-sm"
                  id={"approve-" + thisId}
                  onClick={() => {
                    this.setState({
                      approveUuid: record.retired_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-check"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["approve" + thisId]}
                  target={"approve-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["approve" + thisId]: !this.state["approve" + thisId],
                    });
                  }}
                >
                  Approval
                </Tooltip>
              </span>
            ) : null}
            {accessRole("delete") ? (
              <span>
                {parseInt(status) === -1 || parseInt(status) === 0 ? (
                  <span>
                    <button
                      className="btn btn-danger btn-sm"
                      id={"delete-" + thisId}
                      onClick={() => {
                        this.modal_confirm_status = 1;
                        this.modal_confirm_message =
                          "Apakah anda yakin akan menghapus data ini ?";
                        this.setState({
                          inactiveUuid: record.retired_uuid,
                          confirm: true,
                        });
                      }}
                      style={{
                        padding: "2px 5px",
                      }}
                    >
                      <i className="uil-trash-alt"></i>
                    </button>
                    <Tooltip
                      style={{
                        marginBottom: 2,
                      }}
                      placement="top"
                      isOpen={this.state["delete" + thisId]}
                      target={"delete-" + thisId}
                      toggle={() => {
                        this.setState({
                          ["delete" + thisId]: !this.state["delete" + thisId],
                        });
                      }}
                    >
                      Nonaktifkan
                    </Tooltip>
                  </span>
                ) : (
                  <span></span>
                )}
              </span>
            ) : null} */}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        {/* <Row>
          <label className="">
            Periode&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;
            {this.state.detail.tanggal ? (
              <>
                {this.state.detail.tanggal !== ""
                  ? this.state.detail.tanggal
                  : "-"}
              </>
            ) : (
              <Shimmer>
                <div style={{ width: 68, height: 15 }}></div>
              </Shimmer>
            )}
          </label>
          <label className="">
            Keterangan&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;&nbsp;
            {this.state.detail.keterangan ? (
              <>
                {this.state.detail.keterangan !== ""
                  ? this.state.detail.keterangan
                  : "-"}
              </>
            ) : (
              <Shimmer>
                <div style={{ width: 68, height: 15 }}></div>
              </Shimmer>
            )}
          </label>
        </Row> */}
        <br />
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.modal_confirm_message}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message}
          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/file_persiapan_pensiun.html?detail&uuid=" +
              this.state.detailUuid
            }
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/file_persiapan_pensiun.html?update&uuid=" +
              this.state.updateUuid
            }
          />
        ) : null}
        {/* {this.state.submitUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/file_persiapan_pensiun.html?submit&uuid=" +
              this.state.submitUuid
            }
          />
        ) : null}
        {this.state.approveUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/file_persiapan_pensiun.html?approve&uuid=" +
              this.state.approveUuid
            }
          />
        ) : null} */}
      </>
    );
  }
}

export default TableActiveComponent;
